"use client"

import React from "react"
import { BaseFormElementProps } from "../../utils"
import { TTextarea } from "./TTextarea"

/**
 * @deprecated TTextarea의 value prop을 직접 사용하세요.
 * ```tsx
 * // Before
 * <TTextareaControlled value={text} label="설명" rows={4} onChange={setText} />
 *
 * // After
 * <TTextarea value={text} label="설명" rows={4} onChange={setText} />
 * ```
 */
interface TTextareaControlledProps extends BaseFormElementProps {
	label?: React.ReactNode
	name?: string
	value?: string
	placeholder?: string
	warning?: boolean
	rows?: number
	autoFocus?: boolean
	autoComplete?: string
	spellCheck?: boolean
	disabledEnterKey?: boolean
	renderInnerContent?: React.ReactNode
	onChange?: (value: string) => void
	onClick?: () => void
	onFocus?: () => void
	onBlur?: () => void
	onEnterKey?: (value: string) => void
}

/**
 * @deprecated TTextarea의 value prop을 직접 사용하세요.
 * @example <TTextarea value={text} label="설명" rows={4} onChange={setText} />
 */
export const TTextareaControlled = React.memo(
	React.forwardRef<HTMLTextAreaElement, TTextareaControlledProps>((props, ref) => {
		const {
			id,
			className,
			label,
			name,
			value,
			placeholder,
			required,
			disabled,
			readOnly,
			error,
			warning,
			rows,
			autoFocus,
			autoComplete,
			spellCheck,
			disabledEnterKey,
			renderInnerContent,
			dataAttributes,
			onChange,
			onClick,
			onFocus,
			onBlur,
			onEnterKey
		} = props

		return (
			<TTextarea
				ref={ref}
				id={id}
				className={className}
				label={label}
				name={name}
				value={value}
				placeholder={placeholder}
				required={required}
				disabled={disabled}
				readOnly={readOnly}
				error={error}
				warning={warning}
				rows={rows}
				autoFocus={autoFocus}
				autoComplete={autoComplete}
				spellCheck={spellCheck}
				disabledEnterKey={disabledEnterKey}
				renderInnerContent={renderInnerContent}
				dataAttributes={dataAttributes}
				onChange={onChange}
				onClick={onClick}
				onFocus={onFocus}
				onBlur={onBlur}
				onEnterKey={onEnterKey}
			/>
		)
	})
)

TTextareaControlled.displayName = "TTextareaControlled"
